export class GetTrainingClassesRequest {
    Checksum: string;
}